import { render } from "./newOrder.vue?vue&type=template&id=4854c2e1&scoped=true"
import script from "./newOrder.vue?vue&type=script&lang=js"
export * from "./newOrder.vue?vue&type=script&lang=js"

import "./newOrder.vue?vue&type=style&index=0&id=4854c2e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4854c2e1"]])

export default __exports__